// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';

export const ProjectTeamMembersData = [
	{
		id: 1,
		name: 'Jenny Wilson',
		image: Avatar1,
		topic: 'Front-end Developer, Designer'
	},
	{
		id: 2,
		name: 'Dianna Smiley',
		image: Avatar2,
		topic: 'Front End Developer'
	},
	{
		id: 3,
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 4,
		name: 'Jacob Jones',
		image: Avatar14,
		topic: 'Bootstrap Expert'
	},
	{
		id: 5,
		name: 'Kristin Watson',
		image: null,
		topic: 'Web Development'
	},
	{
		id: 6,
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 7,
		name: 'Rivao Luke',
		image: Avatar17,
		topic: 'Web Development'
	},
	{
		id: 8,
		name: 'Nia Sikhone',
		image: Avatar4,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 9,
		name: 'Xiaon Merry',
		image: Avatar6,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 10,
		name: 'Sina Ray',
		image: Avatar3,
		topic: 'Engineering Architect'
	},
	{
		id: 11,
		name: 'Kristin Watson',
		image: Avatar15,
		topic: 'Web Development'
	},
	{
		id: 12,
		name: 'Jacob Jones',
		image: Avatar14,
		topic: 'Bootstrap Expert'
	},
	{
		id: 13,
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 14,
		name: 'Sina Ray',
		image: Avatar13,
		topic: 'Front End Developer'
	},
	{
		id: 15,
		name: 'Reva Yokk',
		image: Avatar12,
		topic: 'Engineering Architect'
	},
	{
		id: 16,
		name: 'Xiaon Merry',
		image: Avatar18,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 17,
		name: 'Sina Ray',
		image: Avatar3,
		topic: 'Engineering Architect'
	},
	{
		id: 18,
		name: 'Nia Sikhone',
		image: Avatar4,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 19,
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: 20,
		name: 'Rivao Luke',
		image: Avatar17,
		topic: 'Web Development'
	}
];

export default ProjectTeamMembersData;
